import React, { useEffect, useState, useContext } from "react";
import Lang from '../lang/translations';
import Context from '../context/context';

const config = require("../_helpers/configServizi");


export default function Recensioni(props) { 

    const  context = useContext(Context)
    const domain = window.location.hostname;
    const [recensioni, setRecensioni] = useState([]);



    useEffect(() => {
		window.scrollTo({top: 0, behavior: 'smooth'});

	});


    useEffect(() => {  
        setRecensioni(Lang({coppie:true, quante: props.quante || 3, age_range: config.servizi[domain].age_range_recensioni}))
      
   },[]);


  
   
  

    return (<div className="coppie-recensioni-container">
        
            <div className="coppie-recensioni-grid">
                
                {recensioni && recensioni.length > 0 && recensioni.map((coppia, index) => (
                    <div key={index} className="coppia-recensione-card">
                        <div className="coppia-recensione-image-wrapper">
                            <img 
                                src={`${config.servizi[domain].url_foto_utente}/foto_coppie/${coppia.nome_immagine}.jpg`}
                                alt={`${coppia.nome_maschile} e ${coppia.nome_femminile}`}
                                className="coppia-recensione-image"
                            />
                            <div className="coppia-recensione-overlay">
                                <div className="coppia-recensione-names">
                                    <span className="coppia-nome-maschile">{coppia.nome_maschile}</span>
                                    <span className="coppia-separator">&</span>
                                    <span className="coppia-nome-femminile">{coppia.nome_femminile}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
            )

}